import { render, staticRenderFns } from "./SaturationZones.vue?vue&type=template&id=2650ab52&scoped=true&"
import script from "./SaturationZones.vue?vue&type=script&lang=js&"
export * from "./SaturationZones.vue?vue&type=script&lang=js&"
import style0 from "./SaturationZones.vue?vue&type=style&index=0&id=2650ab52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650ab52",
  null
  
)

export default component.exports